// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__sUA7Y","overlay":"Home_overlay__bPEa3","popup":"Home_popup__By-qt","topSeparator":"Home_topSeparator__GykVH","bookNowA":"Home_bookNowA__hw+J1"};